/**
 * Simple LRU cache for permission results
 */
class PermissionCache {
  constructor(maxSize = 100) {
    this.cache = new Map()
    this.maxSize = maxSize
  }

  generateKey(permissions, modifiers) {
    return JSON.stringify({ permissions, modifiers })
  }

  get(permissions, modifiers) {
    const key = this.generateKey(permissions, modifiers)
    const item = this.cache.get(key)

    if (item) {
      // Update access time
      item.lastAccessed = Date.now()
      return item.value
    }
  }

  set(permissions, modifiers, value) {
    const key = this.generateKey(permissions, modifiers)

    // Evict oldest item if cache is full
    if (this.cache.size >= this.maxSize) {
      let oldest = null
      let oldestTime = Infinity

      for (const [k, v] of this.cache.entries()) {
        if (v.lastAccessed < oldestTime) {
          oldest = k
          oldestTime = v.lastAccessed
        }
      }

      if (oldest) {
        this.cache.delete(oldest)
      }
    }

    this.cache.set(key, {
      value,
      lastAccessed: Date.now(),
    })
  }

  clear() {
    this.cache.clear()
  }
}

export const permissionCache = new PermissionCache()
